<main>
    <div class="container main-panel">
        <app-header-ad [position]="'top'"></app-header-ad>

        <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        <div class="row article-row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="article-wrap">
                    <span *ngIf="currentContentEntry">
                        <app-display-content-video [content]="currentContentEntry"></app-display-content-video>
                    </span>                   
                </div>
            </div>
        </div>
        <app-header-ad [position]="'bottom'"></app-header-ad>
    </div>
</main>